export type ProjectOverviewColumnKey =
  | 'client'
  | 'item'
  | 'status'
  | 'notebook'
  | 'wopo'
  | 'uploads'
  | 'estimate'
  | 'invoice'
  | 'components'
  | 'production'
  | 'install'
  | 'customColumn1'
  | 'customColumn2'
  | 'customColumn3';

export type ProjectOverviewColumnVisibility = Partial<Record<ProjectOverviewColumnKey, boolean>>;

export const PROJECT_OVERVIEW_COLUMNS: { key: ProjectOverviewColumnKey; label: string }[] = [
  { key: 'client', label: 'Client/Project' },
  { key: 'item', label: 'Item/Room' },
  { key: 'status', label: 'Status' },
  { key: 'notebook', label: 'Notebook' },
  { key: 'wopo', label: 'WO' },
  { key: 'uploads', label: 'Uploads' },
  { key: 'estimate', label: 'Estimate' },
  { key: 'invoice', label: 'Invoice' },
  { key: 'components', label: 'Components Ordered/Received' },
  { key: 'production', label: 'Production Start/Finish' },
  { key: 'install', label: 'Install No./Date' },
  { key: 'customColumn1', label: 'Custom Field 1' },
  { key: 'customColumn2', label: 'Custom Field 2' },
  { key: 'customColumn3', label: 'Custom Field 3' },
];

export const DEFAULT_PROJECT_OVERVIEW_COLUMN_VISIBILITY: Record<ProjectOverviewColumnKey, boolean> = {
  client: true,
  item: true,
  status: true,
  notebook: true,
  wopo: true,
  uploads: true,
  estimate: true,
  invoice: true,
  components: true,
  production: true,
  install: true,
  customColumn1: false,
  customColumn2: false,
  customColumn3: false,
};

export const resolveColumnVisibility = (
  visibility?: ProjectOverviewColumnVisibility
): Record<ProjectOverviewColumnKey, boolean> => ({
  ...DEFAULT_PROJECT_OVERVIEW_COLUMN_VISIBILITY,
  ...(visibility ?? {}),
});

export const isColumnVisible = (
  visibility: ProjectOverviewColumnVisibility | undefined,
  key: ProjectOverviewColumnKey
): boolean => visibility?.[key] !== false;
